import { Component } from '@angular/core';
import { IonicPage, NavController, LoadingController, Loading } from 'ionic-angular';
import { NgForm } from '@angular/forms';
import { APIOnLine } from '../../services/api/api.services';
import { Online } from '../../models/online/cfutbol';
import { HomePage } from '../home/home';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';

@IonicPage()
@Component({
  selector: 'page-administrador',
  templateUrl: 'administrador.html',
})
export class AdministradorPage {

  public numero: number;

  constructor(
    public CFutbolActas: APIOnLine.CFutbolActas,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public Persistentes: APIOnLine.Persistentes,
    public toastCtrl: ToastController
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AdministradorPage');
  }

  public ObtenerArbitro(form: NgForm): void {
    if (form.valid) {
      let carga: Loading = this.loadingCtrl.create({
        spinner: 'dots',
        content: "obteniendo árbitro"
      });

      this.CFutbolActas.arbitroPorNumero(this.numero)
        .then((resultado: Online.ArbitroBasico) => {
          if (resultado != null && resultado.idArbitro > 0) {
            this.Persistentes.SetArbitro(resultado);

            this.navCtrl.setRoot(HomePage);
            this.navCtrl.first();
          }
          else {
            let toast = this.toastCtrl.create({
              message: "No se ha encontrado el árbitro para el número indicado.",
              duration: 4000
            });
            toast.present();
          }
          carga.dismiss();
        })
        .catch(error => {
          let toast = this.toastCtrl.create({
            message: "Se ha producido un error al intentar la obtención de los datos del árbitro:" + JSON.stringify(error),
            duration: 4000
          });
          toast.present();
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/administrador/administrador.ts